/*
 * TODO - write yesNoConfirm out of svelte dialler and remove this from core.
 * We do not want bootbox to be at the root of our dependency tree.
 */
export const yesNoConfirm = (
  message,
  yesCallback,
  noCallback = null,
  yesLabel = "Yes",
  noLabel = "No",
) =>
  bootbox.confirm({
    message,
    buttons: {
      cancel: {
        label: noLabel,
        className: "btn-light",
      },
      confirm: {
        label: yesLabel,
        className: "btn-primary ml-2",
      },
    },
    callback: (result) => {
      if (result) yesCallback();
      else if (noCallback) noCallback();
    },
  });
